// extracted by mini-css-extract-plugin
export default {"select":"Select_select__fhkh4"};